const NEW_APP_URL = "https://artspacesapp.com/login";

const Decommissioned = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-900 px-6 py-12 text-white">
      <div className="w-full max-w-2xl text-center">
        <span className="inline-block rounded-full border border-white/30 bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-indigo-100">
          Migration Complete
        </span>

        <h1 className="mt-6 text-3xl font-bold tracking-tight md:text-4xl">
          Art Space Chicago has moved
        </h1>

        <p className="mt-4 text-base text-indigo-100 md:text-lg">
          The migration to our new platform is complete. This site is no longer
          active.
        </p>

        <p className="mt-6 text-sm text-indigo-100/90 md:text-base">
          Sign in at the new website using your same credentials, or go through
          Google OAuth sign-in.
        </p>

        <a
          href={NEW_APP_URL}
          className="mt-8 inline-flex items-center justify-center rounded-lg bg-white px-6 py-3 text-base font-semibold text-indigo-900 shadow-lg transition hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-900"
        >
          Go to artspacesapp.com/login
        </a>

        <p className="mt-6 text-sm text-indigo-200/80">
          <a
            href={NEW_APP_URL}
            className="font-medium underline decoration-indigo-300 underline-offset-4 hover:text-white"
          >
            {NEW_APP_URL}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Decommissioned;
